const { NumberUtil } = require("../../utils");
const VoucherHelper = require("../voucher");

const ShipmentPrice = require("./ShipmentPrice");

class OrderPriceAccumulator extends ShipmentPrice {
  constructor() {
    super();
    this.items = {};
    this.voucherDiscount = 0;
  }

  static aggregate(acc, id, itemSummary) {
    if (!(itemSummary instanceof ShipmentPrice)) {
      throw new Error("itemSummary must be an instance of ShipmentPrice");
    }
    acc.items[id] = itemSummary;
    acc.liabilityAmount = acc.liabilityAmount + itemSummary.liabilityAmount;
    acc.parcelAmount = acc.parcelAmount + itemSummary.parcelAmount;
    acc.amount = acc.amount + itemSummary.amount; // liabilityAmount + parcelAmount
    acc.taxAmount = acc.taxAmount + itemSummary.taxAmount;
    acc.totalIncVatAmount =
      acc.totalIncVatAmount + itemSummary.totalIncVatAmount;

    return acc;
  }

  applyVoucherDiscount(voucher) {
    let discount = 0;
    if (VoucherHelper.isValidVoucher(voucher)) {
      discount = voucher.amountIncVat;
      this.totalIncVatAmount = this.totalIncVatAmount - discount;
      this.voucherDiscount = discount;
    }

    return this;
  }

  getVoucherDiscount(precision) {
    return NumberUtil.preciseFloat(this.voucherDiscount, precision);
  }

  toViewJSON(precision) {
    const result = {
      ...super.toViewJSON(precision),
      voucherDiscount: this.getVoucherDiscount(precision),
      items: {},
    };
    for (const id in this.items) {
      if (this.items[id]) {
        result.items[id] = this.items[id].toViewJSON(precision);
      }
    }
    return result;
  }
}

module.exports = OrderPriceAccumulator;
